import { Controller } from "@hotwired/stimulus"
import { enter, leave } from "el-transition"

// Connects to data-controller="ui--snackbar"
export default class extends Controller {
  static values = {
    autoHideDuration: { type: Number, default: 2000 },
  }

  connect() {
    enter(this.element)
    setTimeout(() => {
      this.dismiss()
    }, this.autoHideDurationValue)
  }

  dismiss() {
    leave(this.element).then(() => {
      this.element.remove()
    })
  }
}
